import { resourceState, resourceMutations } from '@/store/utils/resource';
import { tasksClient as client } from '@/api/clients/admin';
import { TASKS } from '@/store/entities/schema_types';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  getters: {
    tasks(state, _, rootState) {
      return state.ids.map((id) => rootState.entities.tasks.byId[id]);
    },
    task(state, _, rootState) {
      if (!state.current) return undefined;
      return rootState.entities.tasks.byId[state.current] || undefined;
    },
  },

  actions: {
    async load(ctx, { params = {} } = {}) {
      try {
        const response = await client.list({ params });
        const { data: payload } = response;
        const { data, meta, links } = payload;

        const taskUuids = await ctx.dispatch(
          'entities/persistEntities',
          { type: TASKS, data },
          { root: true }
        );

        ctx.commit('setIds', taskUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async store(ctx, { formData }) {
      try {
        const {
          data: { data },
        } = await client.store(formData);

        const taskUuid = await ctx.dispatch(
          'entities/persistEntities',
          { type: TASKS, data },
          { root: true }
        );

        return Promise.resolve({ taskUuid });
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async read(ctx, { id, params = {} }) {
      try {
        const response = await client.read(id, { params });
        const { data: payload } = response;
        const { data } = payload;

        await ctx.dispatch('entities/persistEntities', { type: TASKS, data }, { root: true });

        ctx.commit('setCurrent', id);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async update(ctx, { id, body }) {
      try {
        const {
          data: { data },
        } = await client.update(id, body);

        await ctx.dispatch('entities/persistEntities', { type: TASKS, data }, { root: true });

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async destroy(ctx, { taskUuid }) {
      try {
        await client.destroy(taskUuid);

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
